import { useQueries, useQuery } from 'react-query'
import { getJoulyMeterCount, getJoulyMeters } from '../../meter/services/meterAPI'

// Sans `minigridNames`, renvoie le total brut via `getJoulyMeters(1, 1)` (1
// requête, total_count serveur — aligné sur le compteur "X éléments au total"
// de MeterV2List). Avec des noms, appelle `/meters/jouly/count?minigridName=`
// en parallèle pour chaque minigrid sélectionné et somme côté front : chaque
// minigrid filtre les meters par son nom canonique + ses LinkedLocationNames,
// et un meter n'appartient qu'à un seul minigrid (loc.MinigridName est unique
// par compteur), donc l'union = somme.
export function useTotalInstalledMeters(minigridNames?: string[]) {
  const filterActive = (minigridNames?.length ?? 0) > 0

  const totalQuery = useQuery({
    queryKey: ['installed-meters', 'total-count'],
    queryFn: async () => {
      const res = await getJoulyMeters(1, 1)
      return res.pagination.total_count
    },
    staleTime: 5 * 60 * 1000,
    enabled: !filterActive,
  })

  const filteredQueries = useQueries(
    (minigridNames ?? []).map((name) => ({
      queryKey: ['installed-meters', 'by-minigrid', name] as const,
      queryFn: () => getJoulyMeterCount(name),
      staleTime: 5 * 60 * 1000,
      enabled: filterActive,
    })),
  )

  if (!filterActive) {
    return {
      data: totalQuery.data,
      isLoading: totalQuery.isLoading,
      error: totalQuery.error as Error | null,
    }
  }

  const isLoading = filteredQueries.some((q) => q.isLoading)
  const firstError = filteredQueries.find((q) => q.error)?.error as Error | undefined
  const allReady = filteredQueries.every((q) => q.data != null)
  const data = allReady
    ? filteredQueries.reduce((acc, q) => acc + (q.data ?? 0), 0)
    : undefined

  return {
    data,
    isLoading,
    error: firstError ?? null,
  }
}
